"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.LanguagesNameEnum = exports.LanguagesEnum = exports.TYPE = void 0;
const translation_1 = require("../../../translation");
exports.TYPE = 'code';
exports.LanguagesEnum = {
    html: 'html',
    css: 'css',
    javascript: 'javascript',
    node: 'node',
    markdown: 'markdown',
    java: 'java',
    php: 'php',
    python: 'python',
    'c/c++': 'c/c++',
    sql: 'sql',
    liquid: 'liquid',
    ruby: 'ruby',
};
exports.LanguagesNameEnum = {
    [exports.LanguagesEnum.html]: 'HTML',
    [exports.LanguagesEnum.css]: 'CSS',
    [exports.LanguagesEnum.javascript]: 'JavaScript',
    [exports.LanguagesEnum.node]: 'Node',
    [exports.LanguagesEnum.markdown]: 'Markdown',
    [exports.LanguagesEnum.java]: 'Java',
    [exports.LanguagesEnum.php]: 'PHP',
    [exports.LanguagesEnum.python]: 'Python',
    [exports.LanguagesEnum['c/c++']]: 'C/C++',
    [exports.LanguagesEnum.sql]: 'SQL',
    [exports.LanguagesEnum.liquid]: 'Liquid',
    [exports.LanguagesEnum.ruby]: 'Ruby on Rails',
};
exports.DEFAULT_VALUE = {
    code: `<p>${(0, translation_1.t)('elements.code.label')} HTML</p>`,
    lineNumbers: true,
    theme: 'light',
    disabled: false,
    language: exports.LanguagesEnum.html,
    showCopyButton: true,
};
